import { takeEvery, fork, put, all, call } from "redux-saga/effects"

// Login Redux States
import { EDIT_PROFILE } from "./actionTypes"
import { profileSuccess, profileError } from "./actions"

//Include Both Helper File with needed methods
import { getFirebaseBackend } from "../../../helpers/firebase_helper"
import {
  postFakeProfile,
  postJwtProfile,
} from "../../../helpers/fakebackend_helper"

const fireBaseBackend = getFirebaseBackend()

interface EditProfileAction {
  type: string;
  payload: {
    user: {
      username: string;
      idx: string | number;
      [key: string]: any;
    };
  };
}

function* editProfile(action: EditProfileAction): Generator<any, void, any> {
  const { payload: { user } } = action;
  try {
    if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
      if (fireBaseBackend) {
        const response = yield call(
          [fireBaseBackend, 'editProfileAPI'] as any,
          user.username,
          user.idx
        )
        yield put(profileSuccess(response))
      }
    } else if (process.env.REACT_APP_DEFAULTAUTH === "jwt") {
      const response = yield call(postJwtProfile as any, "/post-jwt-profile", {
        username: user.username,
        idx: user.idx,
      })
      yield put(profileSuccess(response))
    } else if (process.env.REACT_APP_DEFAULTAUTH === "fake") {
      const response = yield call(postFakeProfile as any, {
        username: user.username,
        idx: user.idx,
      })
      yield put(profileSuccess(response))
    }
  } catch (error) {
    yield put(profileError(error))
  }
}
export function* watchProfile(): Generator<any, void, any> {
  yield takeEvery(EDIT_PROFILE as any, editProfile)
}

function* ProfileSaga() {
  yield all([fork(watchProfile)])
}

export default ProfileSaga
